package com.merkost.handpass.admin.container

import com.merkost.handpass.admin.api.AdminRepositoryApi
import com.merkost.handpass.admin.contract.EnvLabel
import com.merkost.handpass.admin.contract.SidebarAction
import com.merkost.handpass.admin.contract.SidebarIntent
import com.merkost.handpass.admin.contract.SidebarState
import com.merkost.handpass.admin.platform.WindowFocusTrigger
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import pro.respawn.flowmvi.api.Container
import pro.respawn.flowmvi.dsl.lazyStore
import pro.respawn.flowmvi.plugins.recover
import pro.respawn.flowmvi.plugins.reduce

class SidebarContainer(
    private val repo: AdminRepositoryApi,
    private val focusTrigger: WindowFocusTrigger,
) : Container<SidebarState, SidebarIntent, SidebarAction> {

    private val scope = MainScope()

    override val store by lazyStore<SidebarState, SidebarIntent, SidebarAction>(SidebarState(envLabel = detectEnv()), scope) {
        configure { name = "SidebarStore" }
        recover { _ -> null }
        reduce { intent ->
            when (intent) {
                is SidebarIntent.SetCurrentPath -> updateState { copy(currentPath = intent.path) }
                is SidebarIntent.SetAuth -> updateState { copy(authState = intent.auth) }
                is SidebarIntent.ReactToFocusTick, SidebarIntent.Refresh -> {
                    val stats = repo.getStats()
                    if (stats != null) {
                        updateState { copy(pendingCount = stats.totalQueueSize.toInt()) }
                    }
                }
            }
        }
    }

    init {
        scope.launch {
            focusTrigger.ticks.collect { tick ->
                store.intent(SidebarIntent.ReactToFocusTick(tick))
            }
        }
    }

    companion object {
        private fun detectEnv(): EnvLabel {
            val origin = window.location.origin
            return when {
                origin.contains("localhost") -> EnvLabel.LOCAL
                origin.contains("staging") -> EnvLabel.STAGING
                else -> EnvLabel.PROD
            }
        }
    }
}
